import { render, staticRenderFns } from "./index-payments.vue?vue&type=template&id=754af2fe&"
import script from "./index-payments.vue?vue&type=script&lang=js&"
export * from "./index-payments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports